import React, { useEffect, useState } from "react";
import "./styles.scss";
import { useDispatch, useSelector } from "react-redux";
import { Navigator, TabButton } from "../../../components";
import { getLanguage } from "../../../utils/environment";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { closeMobileMenuModal } from "../../console/redux/actions";
import { setCategory } from "../../Category/redux/actions";
import { useLocation } from "react-router-dom";
import { getAllMenus } from "../../CreateNewItem/CreateNewCategory/service/category.service";
import { setMenuList } from "../../Menus/redux/actions";

const lan = getLanguage();

const Index = (props) => {
  const { isOpenMobileMenuModal } = useSelector(
    ({ consoleReducer }) => consoleReducer
  );

  const dispatch = useDispatch();

  const handleChildData = (childData) => {
    setCategory(childData); // Update state with child data
  };

  const [categoryList, setCategoryList] = useState([]);
  const menusList = useSelector((state) => state.menuReducer.menuList);
  const [menu, setMenu] = useState("home");

  const location = useLocation();

  const goToPage = (key) => {
    console.log("key", key);
    //props.setMenuName(key);
    // eslint-disable-next-line default-case
    switch (key) {
      case "home":
        props.history.push("/");
        break;
      case "hotnews":
        props.history.push("/hotnews");
        break;
      case "gov-jobs":
        props.history.push("/government-jobs");
        break;
      case "gov-gazette":
        props.history.push("/government-gazette");
        break;
      case "contact":
        props.history.push("/contact-us");
        break;
      default:
        props.history.push("/" + key);
    }
  };

  // useEffect(() => {
  //   let param = location.pathname.split("/");

  //   let newCategory = param[1];
  //   if (newCategory !== menu) {
  //     setMenu(newCategory);
  //     props.setMenuName(newCategory);
  //   }
  // }, [location.pathname]);

  useEffect(() => {
    const fetchCategories = async () => {
      const response = await getAllMenus();
      console.log({ response });
      if (response?.data) {
        setCategoryList(response.data);
        dispatch(setMenuList(response.data));
      }
    };
    if (menusList?.langth === 0) {
      fetchCategories();
    }
  }, []);

  return (
    <>
      <div
        className={`common-modal-out-bg-wrapper ${
          isOpenMobileMenuModal ? "open_me" : "close__me"
        }`}
      />
      <div
        className={`common-modal-base-wrapper mobile-menu-modal-wrapper d-flex flex-column animate__animated  ${
          isOpenMobileMenuModal ? "open_me animate__slideInUp" : "close__me"
        }`}
      >
        <div className={"navigator"}>
          <Navigator
            data={{ size: "md", icon: "cross", title: "" }}
            onClickBack={() => {
              dispatch(closeMobileMenuModal());
            }}
          />
          <div></div>
        </div>

        {/* <Menu setMenuName={handleChildData} /> */}

        <div className={`mmmw__menu-wrapper`}>
          <TabButton
            data={{
              tabName: "Home",
              type: "english",
              size: "lg",
              isActive: menu === "home",
            }}
            onClick={() => {
              goToPage("home");
              setMenu("home");
              dispatch(closeMobileMenuModal());
            }}
          />
          <TabButton
            data={{
              lan: lan,
              tabName: lan === "si" ? "රැකියා" : "Government jobs",
              type: "english",
              size: "sm",
              isActive: menu === "gov-jobs",
              // menu === "gov-jobs" ||
              // props.location.pathname?.includes("jobs"),
            }}
            onClick={() => {
              // props.history.push("/gov-jobs");
              goToPage("gov-jobs");
              setMenu("gov-jobs");
              dispatch(closeMobileMenuModal());
            }}
          />
          <TabButton
            data={{
              lan: lan,
              tabName: lan === "si" ? "ගැසට්" : "Gazette",
              type: "english",
              size: "sm",
              isActive: menu === "gov-gazette",
              // menu === "gov-gazette" ||
              // props.location.pathname?.includes("government-gazette"),
            }}
            onClick={() => {
              // props.history.push("/gov-jobs");
              goToPage("gov-gazette");
              setMenu("gov-gazette");
              dispatch(closeMobileMenuModal());
            }}
          />
          {menusList?.map((item, index) => (
            <TabButton
              data={{
                lan: lan,
                tabName: item.menu_name[lan],
                isActive:
                  menu === item.category ||
                  props.location.pathname === "/" + item.category,

                type: lan === "en" ? "english" : "sinhala",
                size: "lg",
              }}
              onClick={() => {
                props.history.push("/" + item.category);
                dispatch(closeMobileMenuModal());
                setMenu(item.category);
              }}
            />
          ))}

          <TabButton
            data={{
              tabName: "Contact us",
              type: "english",
              size: "lg",
              isActive: menu === "contact",
            }}
            onClick={() => {
              goToPage("contact");
              setMenu("contact");
              dispatch(closeMobileMenuModal());
            }}
          />
        </div>
      </div>
    </>
  );
};
export default withRouter(Index);
